<template>
  <v-snackbar class="" :value="alert.show" @input="close" :color="color" :timeout="timeout" top>
    <div class="d-inline-flex relative pa-1 align-start">
      <v-icon size="30" class="mr-5">{{ icon }}</v-icon>
      <div class="mr-15">
        <div class="subtitle-1 font-weight-medium">{{ alert.message.title ? alert.message.title : alert.message }}</div>
        <div
          v-html="alert.message.description"
          class="subtitle-2 font-weight-regular"
          v-if="alert.message.description"
        ></div>
      </div>
      <v-icon class="ml-15 absolute" id="icon_close" size="15" @click="close">mdi-close</v-icon>
    </div>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      alert: this.$alert.alertData,
    }
  },
  computed: {
    icon() {
      return {
        error: 'mdi-close-circle',
        success: 'check_circle',
        warning: 'warning',
      }[this.alert.type]
    },
    color() {
      return {
        error: 'error',
        success: 'success',
        warning: 'yellow darken-2',
      }[this.alert.type]
    },
    timeout() {
      return (
        {
          error: 8000,
        }[this.$alert.type] || 5000
      )
    },
  },
  methods: {
    close() {
      this.$alert.close()
    },
  },
}
</script>
<style>
#icon_close {
  position: absolute;
  right: 15px;
}
</style>
